import { DBDef_EditableTest } from '@nu-art/thunderstorm-shared/_entity/editable-test/index';
import { ThunderDispatcherV3 } from '../../core/db-api-gen/types.js';
import { ModuleFE_BaseApi } from '../../modules/db-api-gen/ModuleFE_BaseApi.js';
export const dispatch_onEditableTestChanged = new ThunderDispatcherV3('__onEditableTestUpdated');
export class ModuleFE_EditableTest_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_EditableTest, dispatch_onEditableTestChanged);
        this._v1 = {};
    }
}
export const ModuleFE_EditableTest = new ModuleFE_EditableTest_Class();
//# sourceMappingURL=ModuleFE_EditableTest.js.map